export default "__VITE_ASSET__$Vv1ItlW__"